import initializeSvelteApp from "common/initializeSvelteApp";
import OnlinePaymentType from "./OnlinePaymentType";
import LegalTerms from "./LegalTerms";
import PaymentButtons from "./PaymentButtons";

initializeSvelteApp({
  component: OnlinePaymentType,
  target: ".js-ticketbuyer-online-payments",
  props: element => {
    return {
      items: JSON.parse(element.getAttribute("data-items")),
      strings: JSON.parse(element.getAttribute("data-strings")),
      currencySymbol: element.getAttribute("data-currency-symbol"),
    };
  },
});

initializeSvelteApp({
  component: LegalTerms,
  target: ".js-legal-terms-inputs",
  props: element => {
    return {
      url: element.getAttribute("data-url"),
      legalTerms: JSON.parse(element.getAttribute("data-legal-terms")),
      strings: JSON.parse(element.getAttribute("data-strings")),
    };
  },
});

initializeSvelteApp({
  component: PaymentButtons,
  target: ".js-payment-buttons",
  props: element => {
    return {
      form: element.getAttribute("data-form"),
      isMobile: element.getAttribute("data-is-mobile") === "true",
      allowShoppingCart: element.getAttribute("data-allow-shopping-cart") === "true",
      strings: JSON.parse(element.getAttribute("data-strings")),
    };
  },
});
